import { render, staticRenderFns } from "./trou_jean.vue?vue&type=template&id=0a0b6244"
import script from "./trou_jean.vue?vue&type=script&lang=js"
export * from "./trou_jean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports